<template lang="pug">
    v-container.restaurant-container(fluid)
        v-dialog(v-if="detailDialog" v-model="detailDialog" persistent="" height="300" max-width='500')
          detailTable(:currentTable="currentTable" @close="closeModal")
        //- Add Restaurant employees
        v-dialog(v-if="restaurentDialog" v-model="restaurentDialog" persistent="" max-width='500')
          createEmployees(:fromStore="true" @close="restaurentDialog=false" @refresh="loadEmployees")
        v-row
            //- Employees
            v-col(cols="12" xs="12" sm="12" md="6" lg="6" xl="6")
                v-card.rounded-card.elevation-5
                    v-card-title.justify-center.main-title-primary
                        | Empleados
                    v-card-text
                        .d-flex.justify-end
                            v-btn.main-btn-gradient(@click="restaurentDialog = true")
                                p.mx-2 Agregar empleados
                        //- Collaborators
                        div(v-if="employees.length > 0" v-for="(employee, index) of employees")
                            v-card.elevation-8.my-2()
                                .d-flex.justify-space-around.align-center
                                    v-icon {{employee.data.role == 'chef' ? 'mdi-chef-hat' : 'mdi-account'}}
                                    p.email-container {{employee.data.email}}
                                    p {{employee.data.role | translateRole}}
                                    v-btn(text color="red" @click="deleteEmployee(employee)")
                                        v-icon mdi-delete
                        noResults(v-if="employees.length === 0" :title="'No has creado Cocineros/Mesoneros'")
            //- Tables
            v-col.pb-8(cols="12" xs="12" sm="12" md="6" lg="6" xl="6" style="position: relative;")
                v-card.rounded-card.elevation-5.pb-5
                    v-card-title.justify-center.main-title-primary Cantidad de mesas
                    v-row.mx-auto
                      v-col.py-0.mb-1(cols="4" md="3" lg="3" xl="2" style="position: relative")
                        v-btn.elevation-8.rounded-card-tables.mb-0(text @click="addTable" :loading="creatingTable")
                          v-icon(size="30") mdi-plus
                        p.rounded-card__title Agregar mesa
                      //- Tables
                      v-col.py-0(cols="4" md="3" lg="3" xl="2" v-for="(table, index) of tables" style="position: relative")
                        v-btn.floating-icon(text small fab :loading="creatingTable" @click="deleteTable(table)")
                          v-icon(color="red") mdi-delete
                        v-card.elevation-8.rounded-card-tables.mb-0(:class="!table.available ? 'unavailable':''" @click="showDetail(table, index)")
                          p.rounded-card-tables__number {{index+1}}
</template>

<script>
  import Swal from 'sweetalert2'
  export default {
    components: {
      createEmployees: () => import('@/views/custom/CreateUser'),
      noResults: () => import('@/components/custom/NoResults'),
      detailTable: () => import('@/components/custom/restaurant/DetailTable'),
    },

    filters: {
      translateRole (role) {
        if (role === 'chef') return 'Cocinero'
        return 'Mesero'
      },
    },

    data: () => ({
      restaurentDialog: false,
      creatingTable: false,
      detailDialog: false,
      currentTable: null,
    }),

    computed: {
      employees () {
        return this.$store.getters['restaurant/getEmployees']
      },
      shop () {
        return this.$store.getters['shops/getCurrentItem']
      },
      tables () {
        return this.$store.getters['restaurant/getTables']
      },
    },

    mounted () {
      const vm = this
      vm.loadEmployees()
      // Load tables
      vm.$store.dispatch('restaurant/loadTables', vm.shop.id)
    },

    beforeDestroy () {
      const vm = this
      vm.$store.dispatch('restaurant/closeLoadTables', vm.shop.id)
    },

    methods: {
      loadEmployees () {
        const vm = this
        vm.restaurentDialog = false
        vm.$store.dispatch('restaurant/loadEmployees', vm.$route.params.id)
      },
      deleteEmployee (item) {
        const vm = this
        Swal.fire({
          title: `Eliminar al ${item.data.role === 'chef' ? 'Cocinero' : 'Mesero'} ${item.data.email}`,
          text: '¿Deseas continuar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2ca0a5',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: (login) => {
            return vm.$store.dispatch('admins/deleteItem', item)
              .then(response => {
                if (response !== 'ok') {
                  throw new Error(response.statusText)
                }
                return 'ok'
              })
          },
        }).then((result) => {
          if (result.isConfirmed) {
            vm.loadEmployees()
          }
        })
      },
      addTable () {
        const vm = this
        vm.creatingTable = true
        vm.$store.dispatch('restaurant/addTable', vm.shop.id).then((res) => {
          vm.creatingTable = false
        }).catch((error) => {
          console.log(error)
          vm.creatingTable = false
        })
      },
      deleteTable (item) {
        const vm = this
        Swal.fire({
          icon: 'warning',
          title: 'Eliminar mesa',
          text: 'Al eliminar la mesa se eliminarán todos los datos y productos. ¿Deseas continuar?',
          showCancelButton: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            vm.creatingTable = true
            vm.$store.dispatch('restaurant/deleteTable', { shop: vm.shop.id, table: item.id }).then((res) => {
              vm.creatingTable = false
            }).catch((error) => {
              console.log(error)
              vm.creatingTable = false
            })
          }
        })
      },
      showDetail (table, index) {
        const vm = this
        vm.currentTable = table
        vm.currentTable.index = index + 1
        vm.detailDialog = true
      },
      closeModal () {
        const vm = this
        vm.currentTable = null
        vm.detailDialog = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .restaurant-container{
    .rounded-card{
      border-radius: 20px;
      height: 400px !important;
      overflow-y: scroll;
      overflow-x: hidden;
      &__title{
        position: absolute;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .unavailable{
      background: #d9544a !important;
      color: white
    }
    .rounded-card{
      scrollbar-width: none;
    }
    .rounded-card::-webkit-scrollbar {
      display: none;
    }
    .email-container{
      width: 200px;
      text-align: center;
    }
    .rounded-card-tables{
      background: #e9e9e9;
      border-radius: 50px;
      height: 80px !important;
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px auto;
      cursor: pointer;
      &__number{
        font-size: 15px;
      }
    }
    .floating-icon{
      position: absolute;
      bottom: -15px;
      right: 10%;
      z-index: 1;
    }

  }
</style>
